"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTimerOutlined = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 22a8 8 0 110-16 8 8 0 010 16zm0-2a6 6 0 100-12.002A6 6 0 0012 20zm-1.005-9c.008-.667.342-1 1.005-1 .663 0 .994.333.994 1v4c0 .667-.33 1-.99 1-.661 0-.997-.333-1.009-1v-4zM10 2h3.995c.672.006 1.008.341 1.008 1.005 0 .663-.336.995-1.008.995H10c-.667 0-1-.332-1-.995 0-.664.333-.999 1-1.005zm9.121 1.707l1.411 1.411c.47.48.471.954.002 1.423-.469.47-.94.466-1.416-.009l-1.41-1.41c-.472-.472-.473-.942-.004-1.412.47-.469.942-.47 1.417-.003z' }))); };
exports.default = SvgTimerOutlined;
//# sourceMappingURL=TimerOutlined.js.map